<template>
  <div id="app">
    <Navbar />
    <div class="content">
      <router-view /> <!-- 這裡顯示對應路由的頁面內容 -->
    </div>
    <Footer />
    <!-- 機器人圖標 -->
    <div
      class="chatbot-icon"
      ref="chatbotIcon"
      @mousedown="startDrag"
      @touchstart="startDrag"
      @mouseup="handleClick"
      @touchend="handleClick"
    >
      <img src="/chatbot.png" alt="Chatbot" />
    </div>
    <!-- 滾動到頂部按鈕 -->
    <button
      class="scroll-to-top"
      ref="scrollToTopButton"
      @mousedown="startDrag"
      @touchstart="startDrag"
      @mouseup="scrollToTop"
      @touchend="scrollToTop"
    >
      <v-icon>mdi-arrow-up</v-icon>
    </button>
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "App",
  components: {
    Navbar,
    Footer,
  },
  data() {
    return {
      dragging: false, // 是否正在拖曳
      longPress: false, // 是否是長按
      startY: 0, // 滑鼠按下起始位置 Y
      offsetY: 700, // 預設距離頁面頂部的偏移量
      containerHeight: 0, // 頁面高度，用於限制拖曳範圍
      navbarHeight: 0, // Navbar 的高度
      clickTimeout: null, // 用於區分點擊和長按的定時器
      iconHeight: 70, // 機器人圖標的高度
      buttonHeight: 40, // 滾動到頂部按鈕的高度
    };
  },
  mounted() {
    this.containerHeight = document.documentElement.clientHeight;

    // 獲取 Navbar 的高度，限制圖標拖曳範圍
    const navbar = document.querySelector("nav"); // 假設 Navbar 的標籤是 <nav>
    this.navbarHeight = navbar ? navbar.offsetHeight : 0;

    // 初始化機器人圖標位置
    this.offsetY = this.containerHeight - 170; // 靠近底部
    this.updatePositions();
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    navigateToChatbot() {
      if (!this.longPress) {
        window.open(
          "https://chat.maiagent.ai/web-chats/f1765caf-8126-4133-bbfb-1d9c86df2ab4",
          "_blank"
        );
      }
    },
    startDrag(event) {
      event.preventDefault();
      this.longPress = false;
      this.dragging = true;

      const target = event.targetTouches ? event.targetTouches[0] : event;
      this.startY = target.clientY;

      this.clickTimeout = setTimeout(() => {
        this.longPress = true;
      }, 300);

      document.addEventListener("mousemove", this.drag);
      document.addEventListener("touchmove", this.drag);
      document.addEventListener("mouseup", this.stopDrag);
      document.addEventListener("touchend", this.stopDrag);
    },
    drag(event) {
      if (!this.dragging || !this.longPress) return;

      const target = event.targetTouches ? event.targetTouches[0] : event;
      const deltaY = target.clientY - this.startY;

      this.offsetY += deltaY;

      // 限制拖曳範圍
      this.offsetY = Math.min(
        this.containerHeight - this.iconHeight, // 不超過頁面底部
        Math.max(this.navbarHeight + 10, this.offsetY) // 不超過 Navbar 下方 10px
      );

      this.updatePositions();

      this.startY = target.clientY;
    },
    stopDrag() {
      this.dragging = false;
      clearTimeout(this.clickTimeout);

      document.removeEventListener("mousemove", this.drag);
      document.removeEventListener("touchmove", this.drag);
      document.removeEventListener("mouseup", this.stopDrag);
      document.removeEventListener("touchend", this.stopDrag);
    },
    handleClick() {
      if (!this.longPress) {
        this.navigateToChatbot();
      }
    },
    updatePositions() {
      const chatbot = this.$refs.chatbotIcon;
      const scrollToTop = this.$refs.scrollToTopButton;

      // 計算兩個元素的垂直中心，增加額外偏移量調整置頂按鈕的位置
      const centerOffset = Math.abs(this.iconHeight - this.buttonHeight) / 2;

      chatbot.style.top = `${this.offsetY}px`;
      chatbot.style.right = `20px`;

      scrollToTop.style.top = `${this.offsetY + centerOffset + 10}px`; // 增加額外偏移量調低位置
      scrollToTop.style.right = `100px`;
    },
  },
};
</script>


<style scoped>
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.content {
  flex: 1;
}

/* 機器人圖標樣式 */
.chatbot-icon {
  position: fixed;
  right: 20px;
  z-index: 1;
  width: 70px;
  height: 70px;
  background-color: #ffffff;
  border-radius: 50%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: grab;
  transition: transform 0.3s, box-shadow 0.3s;
}

.chatbot-icon:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}

.chatbot-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 滾動到頂部按鈕樣式 */
.scroll-to-top {
  position: fixed;
  right: 100px;
  z-index: 1;
  width: 40px; /* 改小按鈕 */
  height: 40px;
  background-color: #246531;
  color: white;
  border: none;
  border-radius: 50%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: grab;
  transition: background-color 0.3s ease, transform 0.3s ease, opacity 0.3s ease;
  opacity: 0.4; /* 增加透明度 */
}

.scroll-to-top:hover {
  background-color: #2e8d36;
  transform: scale(1.1);
  opacity: 0.8; /* 提高透明度 */
}

.scroll-to-top v-icon {
  font-size: 18px; /* 調小按鈕圖標 */
}

/* 通用 reset */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: Arial, sans-serif;
  line-height: 1.6;
  background-color: #f0f0f0;
}
</style>
